// "Last mark-read" signal — when the user most recently marked any post as read
// (reading posts auto-marks them, plus explicit "mark all read"). Stored in
// localStorage under 'last-mark-read'. Used by the Home page to decide whether an
// empty unread list means "you just caught up" (read very recently) vs "nothing new
// has arrived" (last read a while ago).
//
// Unlike lastActive, callers want the CURRENT value (it can change mid-session), so we
// read localStorage fresh each call rather than capturing it at module load.
//
// Missing/invalid => 0 => treated as "very long ago" by callers.

const LAST_MARK_READ_KEY = 'last-mark-read';

/** Epoch ms of the user's most recent mark-read, or 0 if none/invalid. */
export function getLastMarkReadMs(): number {
  try { return Number(window.localStorage.getItem(LAST_MARK_READ_KEY)) || 0; } catch { return 0; }
}

/** Stamp "now" as the user's latest mark-read action. */
export function recordMarkReadNow(): void {
  try { window.localStorage.setItem(LAST_MARK_READ_KEY, String(Date.now())); } catch { /* ignore */ }
}
